import {React, useState,useEffect} from 'react';
import Popup from './Popup';
import Dropdown from './Dropdown';
import EditText from './EditText';
import Button from './Button';
import API_URLS from '../Urls';
import DropdownSearch from './DropdownSearch';

const EditItem = ({ item,type, onClose, onSave}) => { //Componente para editar un item
  const [fetchingUrl, setFetchingUrl] = useState()
  const [fetchedData,setFetchedData] = useState([])
  const [fetchedDrones, setFetchedDrones] = useState([]);
  const [newItemData,setNewItemData] = useState()
  const [compatibleDrones, setCompatibleDrones] = useState([])
  const [editingEnabled,setEditingEnabled] = useState(false)
  const [loading, setLoading] = useState(false);
  const [dronesToDelete,setDronesToDelete] = useState([])
  const [dronesToAdd,setDronesToAdd] = useState([])
  const [selectedDrone, setSelectedDrone] = useState([]);

  const postData = (url, dataToSend, onSuccesful) => {
        console.log("Posting to URL:", url); // Check URL during each post
        console.log("Data to send:", dataToSend);

        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dataToSend)
        })
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
            return response.json();
        })
        .then(data => {
            if (typeof onSuccesful === 'function') onSuccesful(data);
            console.log(data);
        })
        .catch(error => console.error('There was a problem with the fetch operation:', error));
    };
  const deleteData =(url,onSuccesful)=>{
        console.log(url)
        fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }})
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            return response.json();
        })
        .then(data => {
          console.log(data)
          if (typeof onSuccesful === 'function') onSuccesful(data) })// Update the state with fetched data})
        .catch(error => console.error('There was a problem with the fetch operation:', error));}
const fetchDrones = () => {
        fetch(API_URLS.DRONES, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        })
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
            return response.json();
        })
        .then(data => {
            setFetchedDrones(data);
            
        })
        .catch(error => console.error('There was a problem with the fetch operation:', error));
    };

  const fetchData = (url,onSuccesful) => { //Función para obtener los datos del item
    setLoading(true);
    console.log(url)
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data)
        onSuccesful(data)
        setLoading(false);
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error)
        setLoading(false);
      });
  };


useEffect(() => {
  switch (type) {
    case 'Accesorios':
      setFetchingUrl(API_URLS.ACCESORIES)
      break
    case 'Partes':
      setFetchingUrl(API_URLS.PARTS)
      break
    case 'Servicios':
      setFetchingUrl(API_URLS.SERVICES)
      break
    default:
      setFetchingUrl(API_URLS.DRONES)
      break
  }
}, [type])

useEffect(() => {
  if (fetchingUrl && item) {
    fetchData(fetchingUrl + '?id=' + item, data => {
      setFetchedData(data[0])
      if (['Accesorios', 'Partes'].includes(type)) {
  // Decide the URL based on the type
  const url =
    type === 'Accesorios'
      ? `${API_URLS.DRONES_ACCESORIES}?id_accesorio=${data[0].id}`
      : `${API_URLS.DRONES_PARTS}?id_parte=${data[0].id}`;

  fetchData(url, async (compatibleDrones) => {
    // Enrich each compatible drone with extra details
    if(compatibleDrones && compatibleDrones.length>0){
    
    const enriched = await Promise.all(
      
      compatibleDrones.map(async (drone) => {
        try {
          const response = await fetch(`${API_URLS.DRONES}?id=${drone.id_dron}`);
          const details = await response.json();
          return { ...drone, ...details[0] }; // Merge details into the drone object
        } catch (err) {
          console.error(`Error fetching details for drone ${drone.id}:`, err);
          return { ...drone, details: null }; // Keep structure consistent
        }
      })
    );
    console.log(enriched)
    setCompatibleDrones(enriched);
  }});
}

    })
  }
}, [fetchingUrl, item])
useState(()=>{
  console.log(dronesToAdd)
  console.log(compatibleDrones)
},[compatibleDrones,dronesToAdd])

  useEffect(() => { //Función para obtener los datos del item
    if (fetchingUrl && item) {
      fetchData(fetchingUrl + '?id=' + item, data => setFetchedData(data[0])) // Obtiene los datos del item
    }
  }, [fetchingUrl, item])

  const putData = (url, dataToSend, onSuccesful) => { //Función para actualizar los datos del item
      fetch(url, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(dataToSend)
      })
      .then(response => {
          if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
          return response.json();
      })
      .then(data => {
        onSuccesful(data)
      })
      .catch(error => console.error('There was a problem with the fetch operation:', error));
  }

  return ( // Renderiza el componente
    <Popup title={"Editar " + type + " " } onClose={onClose}>
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <div className='header1' style={{ marginBottom: '20px' }}>Información de {type}</div>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <div style={{ fontSize: '18px', color: '#666' }}>Cargando...</div>
          </div>
        ) : (
          (() => {
            const entries = Object.entries(fetchedData);
            const half = Math.ceil(entries.length / 2);
            const firstCol = entries.slice(0, half);
            const secondCol = entries.slice(half);
            return (
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '40px', width: '100%' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'left', gap: '15px', flex: 1 }}>
                  {firstCol.map(([key, value], index) => ( // Muestra los datos del item
                    <div key={index} style={{ display: 'flex', alignItems: 'left', justifyContent: 'left', gap: '10px', width: '100%' }}>
                      <span style={{ fontWeight: 'bold', minWidth: 'auto', textAlign: 'left' }}>{key}:</span>
                      { editingEnabled && key !== 'id' ? (
                        <EditText 
                          defaultText={value ?? ""} 
                          onChange={data=>{setNewItemData({...newItemData,[key]:data})}}
                          style={{ maxWidth: '250px', width: '250px' }}
                        />
                      ) : (
                        <div style={{ padding: '8px 12px', backgroundColor: '#f5f5f5', borderRadius: '4px', minWidth: '120px', maxWidth: '250px', textAlign: 'left' }}>
                           {value}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'left', gap: '15px', flex: 1 }}>
                  {secondCol.map(([key, value], index) => (
                    <div key={index} style={{ display: 'flex', alignItems: 'left', justifyContent: 'left', gap: '10px', width: '100%' }}>
                      <span style={{ fontWeight: 'bold', minWidth: 'auto', textAlign: 'left' }}>{key}:</span>
                      { editingEnabled && key !== 'id' ? (
                        <EditText 
                          defaultText={value ?? ""} 
                          onChange={data=>{setNewItemData({...newItemData,[key]:data})}}
                          style={{ maxWidth: '250px', width: '250px' }}
                        />
                      ) : (
                        <div style={{ padding: '8px 12px', backgroundColor: '#f5f5f5', borderRadius: '4px', minWidth: '120px', maxWidth: '250px', textAlign: 'left' }}>
                           {value}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                
              </div>
            );
          })()
        )}
        {(type=='Partes' || type == 'Accesorios') && (
          <div>
            <div>
                    <div className='header1'>Drones compatibles</div>
                {compatibleDrones && compatibleDrones.map((drone, index) => (
                  <div key={index} style={{ padding: '8px 12px', backgroundColor: '#f5f5f5', borderRadius: '4px', minWidth: '120px', maxWidth: '250px', }}>
                    {drone.linea} - {drone.serie} - {drone.modelo} {" "}
                    {editingEnabled && (
                      <button onClick={()=>{
                        setDronesToDelete(prev=>[...prev,drone.id]);
                        setDronesToAdd(dronesToAdd.filter(item=>item.id!=drone.id));
                        setCompatibleDrones(compatibleDrones.filter(item=>item.id!=drone.id))
                      }}>🗑️</button>
                    )}
                    </div>
                  ))
                  }</div>
            {editingEnabled && (
                  <div><div className="header1">Agregar compatibilidad con dron</div>
                        <div style={{ width: '100%' }}>
                            <div className='invisible-horizontal-container'>
                                Linea:
                                <Dropdown options={['Comercial','Enterprise']} returnSelectedOption={(data)=>setSelectedDrone({...selectedDrone,linea:data})}></Dropdown>
                                Serie:
                                <DropdownSearch placeholder={'Seleccione la serie'} returnSelectedOption={(data)=>{setSelectedDrone({...selectedDrone, serie: data})}} options={[...new Set(fetchedDrones.filter(item => item.linea === selectedDrone.linea).map(item => item.serie))]}></DropdownSearch>
                                Modelo:
                                <DropdownSearch returnSelectedOption={(data)=>{setSelectedDrone(prev => ({ ...prev, modelo: data }));}}placeholder={'Seleccione el modelo'} keys={fetchedDrones.filter(item => item.serie == selectedDrone.serie && item.linea == selectedDrone.linea).map(item => item.id)} returnSelectedKey={(data)=>{setSelectedDrone(prev => ({ ...prev, objectid: data }));}} options={fetchedDrones.filter(item => item.serie == selectedDrone.serie && item.linea == selectedDrone.linea).map(item => item.modelo)}></DropdownSearch>
                                <Button text={"Agregar"} onClick={() => {
                                  if(selectedDrone.objectid){
                                    setDronesToAdd(prev=>[...prev,selectedDrone]);
                                    setCompatibleDrones(prev=>[...prev,selectedDrone])
                                  }else{
                                    alert('Asegurese de seleccionar un modelo de dron')
                                  }}} color={"#61BAA5"}></Button>
                            </div>
                        </div></div>
                )}
          </div>
        )}
        
        <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'center', gap: '15px' }}>
          { !editingEnabled ?(
            <Button text='Editar' onClick={()=>{setEditingEnabled(true);setNewItemData(fetchedData);setSelectedDrone({linea:'Comercial'});fetchDrones()}} style={{ color: 'Black' }}></Button>
          ) : (
            <Button text='Guardar' onClick={() => {
              putData(fetchingUrl,newItemData,async ()=>{
                setEditingEnabled(false);
                const url = type === 'Accesorios'
                      ? `${API_URLS.DRONES_ACCESORIES}`
                      : `${API_URLS.DRONES_PARTS}`;
                const type_id = type === 'Accesorios'
                      ? 'id_accesorio'
                      : 'id_parte';
                 const deletePromises = dronesToDelete.map(item =>
                    deleteData(url + '?' + type_id + '=' + newItemData.id + '&' + 'id_dron=' + item)
                  );
                  const postPromises = dronesToAdd.map(item =>
                    postData(url,
                      {[type_id]:newItemData.id,
                        id_dron:item.objectid
                    })
                  );
                  await Promise.all([
                    ...deletePromises,
                    ...postPromises
                  ]);
                fetchData(fetchingUrl+'?id='+newItemData.id,(data)=>setFetchedData(data[0]));
              });

            }} style={{ color: 'Black' }}></Button>
          )}
        </div>
      </div>

    </Popup>
  );
};

export default EditItem;